const EmbeddedComponents = require('@/vue/EmbeddedComponents');
const PaymentMethodRef = require('@/lib/PaymentMethods/PaymentMethodRef');
const { container } = require('@/container');
const { PAYMENT_METHOD_CHANGED } = require('@/lib/Events/EventNames');
const { updateAngularUi } = require('@/functions/angular');

/**
 * @param $scope
 */
function MellonWebECRCtrl(
    $scope,
) {
    const thisPaymentMethodRef = PaymentMethodRef.CARD_MELLON_WEBECR;

    $scope.$on('$destroy', () => {
        window.rootVueStore.commit('removeActiveEmbeddedComponent', EmbeddedComponents.MELLON_WEBECR_PAYMENT_METHOD_COMPONENT);
    });

    $scope.$on(PAYMENT_METHOD_CHANGED, function (event, newPaymentMethod) {
        const newPaymentMethodRef = newPaymentMethod?.ref;
        if (newPaymentMethodRef === thisPaymentMethodRef) {
            window.rootVueStore.commit('addActiveEmbeddedComponent', { name: EmbeddedComponents.MELLON_WEBECR_PAYMENT_METHOD_COMPONENT });
        } else {
            window.rootVueStore.commit('removeActiveEmbeddedComponent', EmbeddedComponents.MELLON_WEBECR_PAYMENT_METHOD_COMPONENT);
        }
    });

    $scope.$on(
        'payment-modal.void-or-refund-payment-pressed',
        /**
         * @param event
         * @param {Payment} existingPayment
         *
         * @return {Promise<void>}
         */
        async function (event, existingPayment) {
            // This listener will be called if the void/refund button is pressed on any payment.

            // First, check if this is one of ours.
            if (existingPayment?.paymentMethod?.ref !== thisPaymentMethodRef) {
                // Don't care.
                return;
            }

            // Tell PaymentCtrl that we are voiding this payment.
            $scope.setVoidOrRefundInProgress(existingPayment.thirdPartyID);

            // We don't need to switch to the Mellon payment method for this. It can happen from anywhere.

            container.paymentState.setPaymentModalCancelable(false, thisPaymentMethodRef);

            const transactionIntentID = existingPayment.getFromJsonStatusDetail('transactionIntentID');
            const terminalID = existingPayment.getFromJsonStatusDetail('terminalID');
            console.log('Voiding MellonWebECR transaction', transactionIntentID, terminalID);

            container.mellonWebECRDriver
                .voidTransaction(terminalID, transactionIntentID)
                .then((result) => {
                    if (result.success) {
                        // The transaction was voided. Remove it from the cart.
                        // Call removePayment on PaymentCtrl to remove the payment.
                        $scope.removePayment(existingPayment);
                    }
                })
                .finally(() => {
                    // We need to clear the void/refund in progress flag.
                    $scope.setVoidOrRefundInProgress(null);

                    container.paymentState.clearPaymentModalCancelable();
                    updateAngularUi();
                });
        }
    );
}
module.exports = MellonWebECRCtrl;
